import { render, staticRenderFns } from "./BusinessPreview.vue?vue&type=template&id=a6cfe744&scoped=true&"
import script from "./BusinessPreview.vue?vue&type=script&lang=ts&"
export * from "./BusinessPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessPreview.vue?vue&type=style&index=0&id=a6cfe744&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6cfe744",
  null
  
)

export default component.exports